import { jsx } from 'react/jsx-runtime';

const SvgNavAiChatbot = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M7 2H2v5h5V2ZM22 12H2v5h20v-5ZM22 12H7V7h5V2h10v10ZM7 22v-5h5l-5 5Z" }) }));

export { SvgNavAiChatbot as default };
//# sourceMappingURL=NavAiChatbot.es.js.map
